/* Dorabella – carrello: aggiornamento drawer, upsell "Aggiungi", regalo automatico sopra soglia. */
(function () {
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') { if (location.pathname.indexOf('/cart') === 0) location.reload(); return Promise.resolve(); }
    var secs = drawer.getSectionsToRender();
    return fetch(location.pathname + '?sections=' + secs.map(function (s) { return s.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        secs.forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (!el || !data[s.id]) return;
          var src = new DOMParser().parseFromString(data[s.id], 'text/html').querySelector(s.selector || '.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        });
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        drawer.classList.remove('is-empty');
      });
  }
  window.doraRefreshDrawer = refreshDrawer;

  // Upsell "Aggiungi"
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dora-upsell-add]');
    if (!btn) return;
    var card = btn.closest('[data-dora-upsell]');
    var id = card && card.querySelector('[data-dora-upsell-variant]').value;
    if (!id) return;
    btn.disabled = true; btn.textContent = '...';
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () { return refreshDrawer(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cartUpdated')); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Aggiungi'; });
  });

  // Regalo automatico
  var cfg = window.doraGift || {};
  var busy = false;
  function checkGift() {
    if (!cfg.variantId || !cfg.threshold || busy) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var gift = cart.items.find(function (i) { return i.properties && i.properties._dora_gift; });
      var subtotal = cart.items.reduce(function (s, i) { return (i.properties && i.properties._dora_gift) ? s : s + i.final_line_price; }, 0);
      var need = cfg.threshold * 100;
      if (subtotal >= need && !gift && cart.item_count > 0) {
        return post('/cart/add.js', { items: [{ id: Number(cfg.variantId), quantity: 1, properties: { _dora_gift: '1' } }] })
          .then(function (res) { if (!res.status) return refreshDrawer(); cfg.variantId = null; });
      }
      if (gift && (subtotal < need || gift.quantity > 1)) {
        return post('/cart/change.js', { id: gift.key, quantity: subtotal < need ? 0 : 1 }).then(refreshDrawer);
      }
    }).catch(function () {}).then(function () { busy = false; });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(checkGift, 400); }
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
    document.addEventListener('cartUpdated', soon);
    soon();
  });
})();

/* Dorabella – aggiunta rapida dalla card: se la taglia salvata ("La mia taglia") c'è ed è disponibile,
   il pulsante aggiunge subito quella taglia al carrello; lo stesso se il capo ha una sola taglia disponibile.
   Altrimenti resta la finestra "Scegli la taglia". */
(function () {
  function variants(wrap) {
    return String(wrap.getAttribute('data-dora-qa') || '').split('|').filter(Boolean).map(function (x) {
      var p = x.split('~'); return { id: Number(p[0]), size: p.slice(1).join('~') };
    });
  }
  function pick(wrap) {
    var list = variants(wrap);
    if (!list.length) return null;
    var ms = window.DoraMySize, pref = ms && ms.get ? ms.get() : null;
    if (pref) {
      var mine = list.filter(function (v) { return ms.matches(v.size, pref); });
      if (mine.length === 1) return mine[0];
      if (mine.length > 1) return null;
    }
    return list.length === 1 ? list[0] : null;
  }
  function label(root) {
    (root || document).querySelectorAll('[data-dora-qa]').forEach(function (wrap) {
      var v = pick(wrap), span = wrap.querySelector('quick-view > span.hidden');
      if (!span) return;
      if (!wrap.dataset.doraQaText) wrap.dataset.doraQaText = span.textContent;
      span.textContent = v ? 'Aggiungi · ' + v.size : wrap.dataset.doraQaText;
      wrap.classList.toggle('dora-qa-ready', !!v);
    });
  }
  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-dora-qa] quick-view');
    if (!qv) return;
    var wrap = qv.closest('[data-dora-qa]'), v = pick(wrap);
    if (!v) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (qv.classList.contains('loading')) return;
    qv.classList.add('loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { qv.classList.remove('loading'); wrap.removeAttribute('data-dora-qa'); qv.click(); return; }
        return (window.doraRefreshDrawer ? window.doraRefreshDrawer() : Promise.resolve()).then(function () {
          var d = document.querySelector('cart-drawer'); if (d && typeof d.open === 'function') d.open();
          document.dispatchEvent(new CustomEvent('cartUpdated'));
        });
      })
      .catch(function () {})
      .then(function () { qv.classList.remove('loading'); });
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var qv = e.target.closest && e.target.closest('[data-dora-qa] quick-view');
    if (qv) { e.preventDefault(); qv.click(); }
  }, true);
  function init() {
    label();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(label, 120); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function () { label(); });
    document.addEventListener('click', function (e) { if (e.target.closest('.dora-ms, [data-dora-ms-save], [data-dora-ms-open]')) setTimeout(label, 150); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
